import React from 'react'
import { Button, ModalBody, ModalFooter, ModalHeader, Text } from '@chakra-ui/react'
import { routes } from 'routes'
import { Modal } from 'components/modal'

export const UpgradeToPublishRoleModal = ({
    isOpen,
    onClose,
    companyId,
}: {
    isOpen: boolean
    onClose: () => void
    companyId: string
}) => {
    return (
        <Modal hideCloseBtn={false} isOpen={isOpen} onClose={onClose} size="md">
            <ModalHeader>
                This company doesn't have permission to publish jobs
            </ModalHeader>
            <ModalBody>
                <Text mb={'16px'}>
                    In order to publish jobs this company needs to be on a package or have
                    an Offer in place. If the company is negotiating terms then create
                    them an Offer to reflect this.
                </Text>
                <Text>
                    Always speak to the company and inform them of your intentions. If
                    you're unsure, please seek assistance from your manager or the dev
                    team.
                </Text>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={onClose} size="modalFooter">
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    as={'a'}
                    href={routes.createCompanyOffer({ companyId })}
                    size="modalFooter"
                >
                    Create Offer
                </Button>
            </ModalFooter>
        </Modal>
    )
}
